import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Quotation } from 'src/app/shared/models/quotation.model';
import { FormsModule } from '@angular/forms';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { EMAIL_PATTERN } from 'src/app/app.constants';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-step5',
  standalone: true,
  imports: [
    TranslatePipe,
    TextBoxComponent,
    FormsModule,
    NgClass
  ],
  templateUrl: './step5.component.html',
  styleUrl: './step5.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class Step5Component {
  @Input({required: true}) quotation: Quotation;
  @Input() userExistsError: boolean;
  @Input() emailError: boolean;

  @Output() emailValidChange = new EventEmitter<boolean>();

  public isEmailValid = false;

  public validateEmail() {
    this.isEmailValid = EMAIL_PATTERN.test(this.quotation.email);
    this.emailValidChange.emit(this.isEmailValid);
  }
}
